module.exports = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined';



// WEBPACK FOOTER //
// webpack:///node_modules/core-js/internals/array-buffer-native.js